import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {catchError, Observable, of, switchMap} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '../services/environment.service';
@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  active: WritableSignal<boolean> = signal(false);

  activate(): void {
    this.active.set(true);
  }

  deactivate(): void {
    this.active.set(false);
  }

  checkMaintenance(): Observable<boolean> {
    return this.http
      .get<{maintenance: boolean}>(`${this.environmentService.baseUrl}/maintenance`)
      .pipe(
        switchMap((response) => {
          if (response.maintenance) {
            this.activate();
          } else {
            this.deactivate();
          }
          return of(response.maintenance);
        }),
        catchError(() => of(false)),
      );
  }
}
